import dropdownicon from "../../assets/images/icon-arrow-dark.svg";
export default function MobileNav({
  handleToggleMenu,
  connect,
  product,
  company,
}) {
  return (
    <ul>
      <div>
        <li className="py-2">
          Product{" "}
          <img
            src={dropdownicon}
            className="inline"
            onClick={() => handleToggleMenu("product")}
            alt=""
          />
        </li>
        {product ? (
          <div className="flex flex-col bg-slate-100">
            <a className="py-1" href="/">
              Overview
            </a>
            <a className="py-1" href="/">
              Pricing
            </a>
            <a className="py-1" href="/">
              Marketplace
            </a>
            <a className="py-1" href="/">
              {" "}
              Features
            </a>
            <a className="py-1" href="/">
              Integrations
            </a>
          </div>
        ) : (
          ""
        )}
      </div>

      <div>
        <li className="py-2">
          Company{" "}
          <img
            src={dropdownicon}
            className="inline"
            onClick={() => handleToggleMenu("company")}
            alt=""
          />
        </li>
        {company ? (
          <div className="flex flex-col bg-slate-100">
            <a className="py-1" href="/">
              About
            </a>
            <a className="py-1" href="/">
              Team
            </a>
            <a className="py-1" href="/">
              Blog
            </a>
            <a className="py-1" href="/">
              Careers
            </a>
          </div>
        ) : (
          ""
        )}
      </div>

      <div>
        <li className="py-2">
          Connect{" "}
          <img
            src={dropdownicon}
            className="inline"
            onClick={() => handleToggleMenu("connect")}
            alt=""
          />
        </li>

        {connect ? (
          <div className="flex flex-col bg-slate-100">
            <a className="py-1" href="/">
              Contact
            </a>
            <a className="py-1" href="/">
              Newsletter
            </a>
            <a className="py-1" href="/">
              LinkedIn
            </a>
          </div>
        ) : (
          ""
        )}
      </div>
      {/* <span className="divide-y divide-dashed w-10 h-3 bg-slate-600" /> */}
      <div>
        <button className="py-4">Login</button>
        <button className="font-semibold text-center bg-bright-red text-white py-3 px-11 rounded-full">
          Sign Up
        </button>
      </div>
    </ul>
  );
}
